export default {
      id: "oc-icon_off-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_off",
      toString: function () {
        return this.url;
      }
    }